export interface TestHooks {
  advanceTimer(seconds: number): void;
  endRound(): void;
  getScore(): number;
  getCombo(): number;
  getRemaining(): number;
  getStats(): { score: number; hits: number; misses: number; bestCombo: number };
  isPaused(): boolean;
}

declare global {
  interface Window {
    __test?: TestHooks;
  }
}

export function isTestMode(): boolean {
  return new URLSearchParams(window.location.search).has('test');
}

export function installTestHooks(hooks: TestHooks): () => void {
  if (!isTestMode()) return () => {};
  window.__test = hooks;
  return () => {
    if (window.__test === hooks) delete window.__test;
  };
}
